/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import React, { MutableRefObject } from 'react';
import InputMask, { MaskedInputProps } from 'react-text-mask';
import { Input } from 'formComponents';

export const PhoneInput = React.forwardRef((props: MaskedInputProps, ref: React.Ref<HTMLInputElement>) => {
  const { value } = props;
  const [showMask, setShowMask] = React.useState(false);
  const [isFocus, setFocus] = React.useState(false);
  const handleFocus = () => {
    setShowMask(true);
    setFocus(true)
  }
  const handleBlur = () => setFocus(false);

  React.useEffect(() => {
    if (showMask && isFocus && ref) {
      const patt = /\d/g;
      const currentValue = (ref as MutableRefObject<HTMLInputElement>).current.value;
      const matchLength = currentValue?.match(patt)?.length;
      if (matchLength) {
        const position = matchLength === 1 ? 3
          : matchLength < 4 ? matchLength + 2
          : matchLength === 4 ? 7
          : matchLength < 7 ? matchLength + 4
          : matchLength < 9 ? matchLength + 5
          : matchLength + 6;
        (ref as MutableRefObject<HTMLInputElement>).current?.setSelectionRange(position, position);
      }
    }
  }, [showMask, isFocus])

  return (
    <InputMask
      showMask={showMask}
      render={(textMaskRef, inputProps) => (
        <Input
          {...inputProps}
          value={value}
          onFocus={handleFocus}
          onBlur={handleBlur}
          ref={(node: HTMLInputElement) => {
            if (node) {
              textMaskRef(node);
              if (ref) {
                (ref as MutableRefObject<HTMLInputElement>).current = node;
              }
            }
          }}
        />
      )}
      {...props}
    />
  )

})